import { render, staticRenderFns } from "./GroupsInfo.vue?vue&type=template&id=9b1e12b0&scoped=true"
import script from "./GroupsInfo.vue?vue&type=script&lang=js"
export * from "./GroupsInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupsInfo.vue?vue&type=style&index=0&id=9b1e12b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1e12b0",
  null
  
)

export default component.exports